module.exports = __webpack_public_path__ + "static/media/termo-retratil-311x210.e2a193e7.png";